import { useCallback } from "react"

import type { SoftReceiveFormValues } from "../../../schemas"

import { type SoftReceiveInput, useSoftReceiveGoodsReceipt } from "./useSoftReceiveGoodsReceipt"

import type { GoodsReceipt } from "@/graphql/codegen/graphql"

interface UseGoodsReceiptSoftReceiveProps {
  goodsReceipt: GoodsReceipt | null
  onRefetch: () => void
  onSoftReceiveSuccess: () => void
}

interface UseGoodsReceiptSoftReceiveReturn {
  isReceiving: boolean
  handleSoftReceiveSubmit: (data: SoftReceiveFormValues) => Promise<void>
}

export const useSoftReceiveGoodsReceiptHandler = ({
  goodsReceipt,
  onRefetch,
  onSoftReceiveSuccess,
}: UseGoodsReceiptSoftReceiveProps): UseGoodsReceiptSoftReceiveReturn => {
  const { softReceive, isReceiving } = useSoftReceiveGoodsReceipt()

  const handleSoftReceiveSubmit = useCallback(
    async (data: SoftReceiveFormValues) => {
      if (!goodsReceipt) return

      const input: SoftReceiveInput = {
        estimatedPalletsCount: data.estimatedPalletsCount ?? null,
        deliveredPalletsCount: data.deliveredPalletsCount ?? null,
        spacesUsed: data.spacesUsed ?? null,
        comment: data.comment ?? null,
      }

      await softReceive(goodsReceipt, input, () => {
        onSoftReceiveSuccess()
        onRefetch()
      })
    },
    [goodsReceipt, softReceive, onSoftReceiveSuccess, onRefetch]
  )

  return {
    isReceiving,
    handleSoftReceiveSubmit,
  }
}
